var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"withdraw-depot-view"},[_c('WithdrawDepot',{attrs:{"depot":_vm.depot,"saldo":_vm.saldo,"payouts":_vm.payouts,"blocked":_vm.blocked,"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }